import React from 'react';
import { useTranslation, SUPPORTED_LANGUAGES } from '../../utils/LanguageContext';

const LanguageSelector = ({ onLanguageChange }) => {
  const { language, setLanguage } = useTranslation();

  const handleChange = (e) => {
    const newLang = e.target.value;
    setLanguage(newLang);
    onLanguageChange?.(newLang);
  };

  return (
    <select
      value={language}
      onChange={handleChange}
      className="block w-32 py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm"
    >
      {Object.entries(SUPPORTED_LANGUAGES).map(([code, name]) => (
        <option key={code} value={code}>
          {name}
        </option>
      ))}
    </select>
  );
};

export default LanguageSelector;